import React, { useCallback, useState, useContext, useEffect } from 'react';
import { Handle, Position } from '@xyflow/react';
import styled from 'styled-components';
import {
  Avatar,
  Button,
  Heading,
  Tooltip as SuperopsTooltip,
  Modal,
  Sheet,
  DisplayText,
  ResourceList,
  ResourceItem,
  TextStyle,
  Badge
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import envConfig from '@nile/home/src/Config/env';
import {
  getTranslatedText,
  COMMON_CONSTANTS,
  useProduct,
  isAuthorised,
  AppContext,
  SelectionSheet,
  toast,
  Loader,
  DateTimeFormatter,
  withErrorBoundary
} from '@nile/components';
import { injectIntl, FormattedMessage } from 'react-intl';
import { TicketClient, GET_RUNBOOK_APPROVERS } from '@nile/graphql';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { isEmpty } from 'lodash';
import { TABLE_ROW_COUNT } from '@nile/rmm/src/constants';

function RunScriptsOutput(props) {
  const {
    intl,
    action,
    toggleRunScriptsOutputModalActive,
    ticket,
    runbookId,
    runScriptsOutputModalActive,
    onSheetClose
  } = props;

  const [viewOutputContent, setViewOutputContent] = useState({
    isOpen: false,
    scriptOutputMessage: 'In Progress'
  });

  const scripts = runScriptsOutputModalActive?.scripts;

  const viewOutputContentFunc = (scriptOutputMessage) => {
    setViewOutputContent({
      isOpen: true,
      scriptOutputMessage
    });
  };

  const backToScriptsList = () => {
    setViewOutputContent({
      isOpen: false,
      scriptOutputMessage: ''
    });
  };

  const getBadgeStatus = (sctipStatus) => {
    switch (sctipStatus) {
      case 'SUCCESS':
      case 'Success':
        return 'success';
      case 'Failure':
        return 'critical';
      default:
        return 'attention';
    }
  };

  return (
    <Modal
      title={getTranslatedText(
        intl,
        'admin.runbooks.templateactions.runscript'
      )}
      open={runScriptsOutputModalActive.isOpen}
      showCloseButton
      onClose={toggleRunScriptsOutputModalActive}
      large
    >
      <Modal.Section>
        {!scripts && <Loader />}
        {scripts && !viewOutputContent.isOpen && (
          <ResourceList
            items={scripts}
            renderItem={(item) => {
              const { script, asset, time, actionOutput } = item;
              const media = <SVGIcon name="AssetPC" />;

              return (
                <ResourceItem
                  id={script.scriptId}
                  media={media}
                  accessibilityLabel={`View details for ${asset.name}`}
                >
                  <div className="flex justify-between">
                    <div>
                      <h3>
                        <TextStyle variation="strong">{asset.name}</TextStyle>
                      </h3>
                      <DateTimeFormatter type="dateTime" date={time} />
                    </div>

                    <div className="flex center  gap-40">
                      {actionOutput?.executionStatus && (
                        <Badge
                          status={getBadgeStatus(actionOutput?.executionStatus)}
                        >
                          {actionOutput?.executionStatus}
                        </Badge>
                      )}

                      <Button
                        onClick={() =>
                          viewOutputContentFunc(
                            actionOutput?.statusMessage?.trim()
                          )
                        }
                      >
                        {' '}
                        View Output{' '}
                      </Button>
                    </div>
                  </div>
                </ResourceItem>
              );
            }}
          />
        )}
        {viewOutputContent?.isOpen && (
          <div>
            <Button
              icon={<SVGIcon name="BackArrow"></SVGIcon>}
              onClick={backToScriptsList}
            ></Button>
            <span className="ml-20">
              {' '}
              {viewOutputContent?.scriptOutputMessage ||
                getTranslatedText(intl, 'asset.script.no.output.to.display')}
            </span>
          </div>
        )}
      </Modal.Section>
    </Modal>
  );
}

export default withErrorBoundary(injectIntl(RunScriptsOutput));
